import '../App.css';

export default function CSVDownloader({ onDownload }) {
  return (
    <button className="primary-button" onClick={onDownload}>
      Download CSV
    </button>
  );
}
